<template>
  <div>
    <base-dialog :show="!!error" title="An error occurred" @close="handleError">
      <p>{{ error }}</p>
    </base-dialog>
    <base-dialog :show="isLoading" fixed title="Authenticating...">
      <base-spinner></base-spinner>
    </base-dialog>
    <base-card>
      <form @submit.prevent="submitForm">
        <div class="form-control">
          <label for="email">E-Mail</label>
          <input type="email" id="email" v-model.trim="email" />
        </div>
        <div class="form-control">
          <label for="password">Password</label>
          <input type="password" id="password" v-model.trim="password" />
        </div>
        <p v-if="!formIsValid">Please enter a valid email and password to {{ submitButtonCaption }} (or valid email only for Password Reset)</p>
        <base-button>{{ submitButtonCaption }}</base-button>
        <base-button type="button" mode="flat" @click="switchAuthMode">{{
          switchModeButtonCaption
        }}</base-button>
        <base-button type="button" mode="flat" @click="forgotPassword">{{
          "Forgot Password?"
        }}</base-button>
      </form>
    </base-card>
  </div>
</template>

<script>
import ShowSnackbar from "../../mixins/ShowSnackbar.js";

export default {
  mixins: [ShowSnackbar],
  data() {
    return {
      email: '',
      password: '',
      formIsValid: true,
      mode: 'login',
      isLoading: false,
      error: null,
    };
  },
  computed: {
    submitButtonCaption() {
      if (this.mode === 'login') {
        return 'Login';
      } else {
        return 'Register';
      }
    },
    switchModeButtonCaption() {
      if (this.mode === 'login') {
        return 'Register instead';
      } else {
        return 'Login instead';
      }
    },
  },
  methods: {
    async submitForm() {
      this.formIsValid = true;

      if ( this.email === '' )
      {
        this.formIsValid = false;
        this.error = "Email must not be blank"
        return;
      } else if ( !this.email.includes('@') ) {
        this.formIsValid = false;
        this.error = "Please enter a valid email address"
        return;
      } else if ( this.password.length < 6 ) {
        this.formIsValid = false;
        this.error = "Password must be at least 6 characters long"
        return;
      }

      this.isLoading = true;

      const actionPayload = {
        email: this.email,
        password: this.password,
      };
      try {
        if (this.mode === 'login') {
          await this.$store.dispatch('login', actionPayload);
        } else {
          await this.$store.dispatch('signup', actionPayload);
        }

        this.openSnackbar("Logged in successfully", "success");
        const redirectUrl = '/' + (this.$route.query.redirect || 'users/' + this.$store.getters.userId);

        this.$router.replace(redirectUrl);
      } catch (err) {
        this.error = err.message || 'Failed to authenticate, try later.';
      }

      this.isLoading = false;
    },
    switchAuthMode() {
      if (this.mode === 'login') {
        this.mode = 'signup';
      } else {
        this.mode = 'login';
      }
    },
    handleError() {
      this.error = null;
    },
    async forgotPassword() {
      this.formIsValid = true;

      if ( this.email === '' )
      {
        this.formIsValid = false;
        this.error = "Email must not be blank"
        return;
      } else if ( !this.email.includes('@') ) {
        this.formIsValid = false;
        this.error = "Please enter a valid email address"
        return;
      }

      this.isLoading = true;

      try {
        await this.$store.dispatch('resetPassword', this.email);

        this.openSnackbar("Password reset sent successfully, check your email", "success");
      } catch (err) {
        this.error = err.message || 'Failed to reset password, try later.';
      }

      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
form {
  margin: 1rem;
  border-radius: 12px;
  padding: 1rem;
}

.form-control {
  margin: 0.5rem 0;
}

label {
  font-weight: bold;
  margin-bottom: 0.5rem;
  display: block;
}

input,
textarea {
  display: block;
  width: 100%;
  font: inherit;
  border: 1px solid #ccc;
  padding: 0.15rem;
}

input:focus,
textarea:focus {
  border-color: #3d008d;
  background-color: #faf6ff;
  outline: none;
}

/* @media(min-width: var(--mobile-breakpoint)) {
} */

</style>